export default __webpack_public_path__ + "static/media/CrownBuilding.75f974b6.svg";